import { Editor } from '@tiptap/react'
import { useMemo } from 'react'

import { BG_COLOR_VARIANT, FG_COLOR_VARIANT } from '../../constants'

import getMarkAttributesForCurrentSelection from '~lib/editor/helpers/getMarkAttributesForCurrentSelection'

export interface ColorOption<T> {
  label?: string
  value: T
}

const fontOptions: ColorOption<FG_COLOR_VARIANT>[] = Object.values(FG_COLOR_VARIANT).map((color) => {
  return { value: color }
})

const backgroundOptions: ColorOption<BG_COLOR_VARIANT>[] = Object.values(BG_COLOR_VARIANT).map((color) => {
  return { value: color }
})

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useColorPicker = (editor: Editor) => {
  return useMemo(
    () => ({
      fontOptions,
      setFontColor: (value: FG_COLOR_VARIANT) => editor.chain().focus().setFontColor(value).run(),
      unsetFontColor: () => editor.chain().focus().unsetFontColor().run(),
      getCurrentFontColor: () => getMarkAttributesForCurrentSelection(editor.state, 'customTextStyle').color,
      backgroundOptions,
      setBackgroundColor: (value: BG_COLOR_VARIANT) => editor.chain().focus().setBackgroundColor(value).run(),
      unsetBackgroundColor: () => editor.chain().focus().unsetBackgroundColor().run(),
      getCurrentBackgroundColor: () =>
        getMarkAttributesForCurrentSelection(editor.state, 'customTextStyle').backgroundColor,
    }),
    [editor]
  )
}
